module.exports = __webpack_public_path__ + "img/134.505a0992.jpg";